import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

function PromotionalBanner() {
  const navigate = useNavigate();
  const handleClick = (e) => {
    e.stopPropagation(); 
    navigate('/signup');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      onClick={handleClick}
      className="bg-[#f05477] hover:bg-[#d03357] text-white py-2 px-4 text-center shadow-md transition-colors cursor-pointer"
      style={{
        position: 'relative',
        zIndex: 1000,
      }}
    >
      <div className="flex items-center justify-center space-x-2">
        <Gift className="h-5 w-5" />
        <p className="text-sm font-medium">
          Sign up and get 10 free credits. No credit card required.
        </p>
      </div>
    </motion.div>
  );
}

export default PromotionalBanner;